<template>
  <content-panel class="pre-plan-classify">
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="80px">
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCode" placeholder="请输入" @keyup.enter.native="search"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productName" placeholder="请输入" @keyup.enter.native="search"></el-input>
          </el-form-item>
          <el-form-item label="产品分类">
            <el-select v-model="searchForm.categoryNames" multiple collapse-tags clearable filterable placeholder="请选择">
              <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="search">查询</el-button>
          <el-button type="warning" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="goImport">导入</el-button>
        <el-button type="primary" size="mini" @click="exportList">导出</el-button>
        <el-button type="primary" size="mini" @click="openDialog">新增</el-button>
      </template>
      <el-table
        :data="tableData.records"
        :height="maxTableHeight"
        border
        stripe
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column prop="productCode" label="产品编码" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="categoryName" label="产品分类" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operatorName" label="更新人" width="120"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" width="180"></el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="openDialog(scope.row)">编辑</el-link>
            <el-link type="danger" :underline="false" style="margin-left: 10px" @click="remove(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>

    <product-category-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :row-data="rowData"
      @success="init"
    ></product-category-dialog>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import ProductCategoryDialog from './ProductCategoryDialog.vue';

export default {
  name: 'PrePlanClassify',
  components: { ProductCategoryDialog },
  mixins: [tableMixin],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      rowData: {},
      categoryOptions: [],
      searchForm: {
        productCode: '',
        productName: '',
        categoryNames: [],
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  mounted() {
    this.getCategoryOptions();
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      const data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm,
      };
      this.$q.preSalePlan
        .preSaleProductCategoryListPage({ data })
        .then((res) => {
          if (res.success && res.data) {
            this.tableData = res.data;
          } else {
            this.tableData.records = [];
            this.tableData.total = 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCategoryOptions() {
      this.$q.preSalePlan.preSaleProductCategoryOptions().then((res) => {
        if (res.success) {
          this.categoryOptions = res.data || [];
        }
      });
    },
    search() {
      this.tableData.pageNum = 1;
      this.init();
    },
    reset() {
      this.searchForm = {
        productCode: '',
        productName: '',
        categoryNames: [],
      };
      this.search();
    },
    handleSizeChange(value) {
      this.tableData.pageSize = value;
      this.tableData.pageNum = 1;
      this.init();
    },
    handleCurrentChange(value) {
      this.tableData.pageNum = value;
      this.init();
    },
    openDialog(row) {
      this.rowData = row ? { ...row } : {};
      this.dialogVisible = true;
    },
    goImport() {
      this.$router.push({
        path: '/order/orderDistribution/prePlanClassifyImport',
        query: {
          appCode: 'ec-pc-new',
          reportName: 'preSaleProductCategory',
        },
      });
    },
    exportList() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const data = {
        appCode: 'ec-pc-new',
        paramMap: this.searchForm,
        reportName: 'productCategoryListPage',
      };
      this.$q.common.exportExcel({ data }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
        } else {
          this.$message.error(res.message);
        }
      }).finally(() => {
        loading.close();
      });
    },
    remove(row) {
      this.$confirm('是否确认删除该条数据？', '提示', { type: 'warning' }).then(() => {
        this.$q.preSalePlan.preSaleProductCategoryDelete({ data: { dataId: row.dataId } }).then((res) => {
          if (res.success) {
            this.$message.success('删除成功');
            this.init();
            this.getCategoryOptions();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        });
      }).catch(() => {});
    },
  },
};
</script>

<style lang="stylus" scoped>
.pre-plan-classify
  >>> .el-input, >>> .el-select
    width 180px

.pagination
  text-align right
</style>
